import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=da8251e0"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports